import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { lookupUserDisplayName, userInitials } from '../utils/userDisplay';

interface UserProviderChipProps {
  providerId?: string | null;
  displayNames: Record<string, string>;
  namesLoading?: boolean;
  /** Shown when providerId is missing (e.g. system / extension tasks). */
  fallbackLabel?: string;
}

const chipSx = {
  minWidth: 28,
  height: 22,
  '& .MuiChip-label': { px: 0.75, fontSize: '0.7rem', fontWeight: 600 },
};

/** Initials chip with tooltip showing the user's full name (or fallback label). */
export const UserProviderChip: React.FC<UserProviderChipProps> = ({
  providerId,
  displayNames,
  namesLoading = false,
  fallbackLabel,
}) => {
  if (!providerId) {
    if (!fallbackLabel) {
      return null;
    }
    const short = fallbackLabel.length >= 2 ? fallbackLabel.slice(0, 2).toUpperCase() : fallbackLabel;
    return (
      <Tooltip title={fallbackLabel}>
        <Chip label={short} size="small" variant="outlined" sx={chipSx} />
      </Tooltip>
    );
  }

  const displayName = lookupUserDisplayName(displayNames, providerId);

  let chipLabel = '?';
  let tooltip = 'Unknown user';
  if (displayName) {
    chipLabel = userInitials(displayName);
    tooltip = displayName;
  } else if (namesLoading) {
    chipLabel = '…';
    tooltip = 'Loading…';
  }

  return (
    <Tooltip title={tooltip}>
      <Chip label={chipLabel} size="small" variant="outlined" sx={chipSx} />
    </Tooltip>
  );
};

export default UserProviderChip;
